<template>
  <div class="d-flex flex-column h-100">
    <div class="d-flex mb-2">
      <input-debounced
          v-model="filters.search"
          clearable
          :autofocus="true"
          placeholder="Search"
          class="mr-1"
      ></input-debounced>
      <button class="btn btn-secondary" @click="refresh"><i class="fas fa-sync-alt"></i></button>
    </div>
    <group-list ref="list" :url="url"></group-list>
  </div>
</template>

<script>
import GroupList from './group-list';
import InputDebounced from '../../../input-debounced';
import {addQueryParams} from "../../../../libs/url";

export default {
  components: {
    GroupList,
    InputDebounced,
  },

  props: {
    indexUrl: String
  },

  data() {
    return {
      filters: {},
    };
  },

  computed: {
    /**
     * @return {String}
     */
    url() {
      return addQueryParams(this.indexUrl, _.pickBy(this.filters));
    }
  },

  methods: {
    refresh() {
      this.$refs.list.refresh();
    },
  },
}
</script>
